export const EoiValidationLabels = {
    addressLine1: { english: 'Address line 1', spanish: 'Línea de dirección 1' },
    addressLine2: { english: 'Address line 2', spanish: 'Línea de dirección 2' },
    city: { english: 'City', spanish: 'Ciudad' },
    applicantInitials: { english: 'Applicant initials', spanish: 'Iniciales del solicitante' },
};
